import {useStoreInfo} from '../../store/utils';
import {BLACKLIST_STORES_FOR_PRODUCT_SEARCH} from '../constants';

export function useSearchProductEnabled() {
  const store = useStoreInfo();

  const isInBlackList = BLACKLIST_STORES_FOR_PRODUCT_SEARCH.some(
    storeId => store && store.id === storeId
  );

  return !isInBlackList;
}
